import e from "./SchemaEnumPropertyItem.vue.script.js";
//#region src/schema/SchemaEnumPropertyItem.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=SchemaEnumPropertyItem.vue.js.map